export const ProjectTile = ({ monogram, color, className = "" }) => (
  <div
    className={`relative w-full overflow-hidden ${className}`}
    style={{ background: `linear-gradient(135deg, ${color} 0%, #0A0A14 130%)` }}
  >
    <span className="absolute top-6 left-8 w-5 h-5 rounded-sm bg-white/25 rotate-12" aria-hidden="true" />
    <span className="absolute top-14 left-16 w-3 h-3 rounded-sm bg-[#FF8A00]/80 -rotate-12" aria-hidden="true" />
    <span className="absolute top-8 right-16 w-4 h-4 rounded-sm bg-[#00D2FF]/70 rotate-45" aria-hidden="true" />
    <span className="absolute top-20 right-8 w-2.5 h-2.5 rounded-sm bg-white/30" aria-hidden="true" />
    <span className="absolute bottom-16 left-10 w-3.5 h-3.5 rounded-sm bg-[#E0146B]/70 rotate-12" aria-hidden="true" />
    <span className="absolute bottom-8 right-24 w-4 h-4 rounded-sm bg-white/15 -rotate-6" aria-hidden="true" />
    <span
      className={`absolute -bottom-12 -right-2 font-display font-black leading-none text-white/10 select-none ${
        monogram.length > 1 ? "text-[9rem]" : "text-[13rem]"
      }`}
      aria-hidden="true"
    >
      {monogram}
    </span>
    <span
      className="absolute bottom-8 left-8 font-display font-bold text-white/90 text-lg tracking-tight"
      aria-hidden="true"
    >
      {monogram}
      <span style={{ color }} className="text-white">.</span>
    </span>
  </div>
);
